export const getExamHeading = (activityType) => {
  const isEexam = activityType.includes('eExam');
  const isMoodleQuiz = activityType.includes('MoodleQuiz');

  if (isEexam && activityType.includes('(Final)')) {
    return 'Final assessment (eExam)';
  }

  if (isEexam && activityType.includes('(In-sem)')) {
    return 'In-semester assessment (eExam)';
  }

  if (isMoodleQuiz && activityType.includes('(Final)')) {
    return 'Final assessment (Moodle quiz)';
  }

  if (isMoodleQuiz && activityType.includes('(In-sem)')) {
    return 'In-semester assessment (Moodle quiz)';
  }

  if (activityType.includes('Dept')) {
    return 'Final assessment';
  }

  return 'Assessment (check Allocate+)';
};
